// extracted by mini-css-extract-plugin
export default {"icon-end":"aqRAkdceNXuzMjjaIVzH yJYhoe85j2fmKeRpw5Cj","iconEnd":"aqRAkdceNXuzMjjaIVzH yJYhoe85j2fmKeRpw5Cj"};